import React, { ReactElement, ReactHTMLElement } from "react";
import styled from "styled-components";

export default function ProjectBtns({ children }: any) {
  return <ProjectButton>{children}</ProjectButton>;
}

const ProjectButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 1024px) {
    flex-direction: row;
    justify-content: center;
  }

  > button > a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

  > button {
    display: inline-block;
    background: rgba(185, 185, 185, 0.44);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
    margin: 20px 15px;
    max-width: 110px;
    width: 100%;
    min-width: 60px;
    height: 50px;
    border: 1px solid #4f4f4f;
    border-radius: 6px;
    transition: all 0.2s ease-in;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    color: white;
    z-index: 1;
      font-size: 1rem;
    font-weight: bold;

    &:before {
      content: "";
      position: absolute;
      left: 50%;
      transform: translateX(-50%) scaleY(1) scaleX(1.25);
      top: 100%;
      width: 140%;
      height: 180%;
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 50%;
      display: block;
      transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
      z-index: -1;
    }

    &:after {
      content: "";
      position: absolute;
      left: 55%;
      transform: translateX(-50%) scaleY(1) scaleX(1.45);
      top: 180%;
      width: 160%;
      height: 190%;
      background: rgba(185, 185, 185, 0.8);
      border-radius: 50%;
      display: block;
      transition: all 0.5s 0.1s cubic-bezier(0.55, 0, 0.1, 1);
      z-index: -1;
    }

    &:hover {
      color: black;
      border: background: rgba(185, 185, 185, 0.8);
    }

    &:hover:before {
      top: -35%;
      background: rgba(185, 185, 185, 0.8);
      transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
    }

    &:hover:after {
      top: -45%;
      background: rgba(185, 185, 185, 0.8);
      transform: translateX(-50%) scaleY(1.3) scaleX(0.8);
    }
  }
`;
